var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { delay, isNil, throttle, uniqueId } from 'lodash-es';
import { SdsTree } from '../tree/sds-tree.lit';
import { ArrangeableList } from '../utilities/arrangable-list/arrangeable-list-impl';
import { createFlatListInspector, createHierarchicalListInspector, } from '../utilities/arrangable-list/list-element-inspector';
import { createFlatListManipulator, createHierarchicalListManipulator, } from '../utilities/arrangable-list/list-element-manipulator';
import { sdsCustomElement } from '../utilities/custom-components';
import { appendStylesToTheGlobalStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-arrangeable-list--global.lit.scss';
import styles from './sds-arrangeable-list.lit.scss';
import { SdsList } from '../list/sds-list.lit';
/**
 * `SdsArrangeableList` is a LitElement web component that provides an interactive list with arrangeable capabilities.
 * Users can rearrange the order of list items through drag-and-drop interactions. The component can be used in
 * both flat and hierarchical modes, accommodating simple lists and tree structures.
 *
 * It supports slots for list items and emits custom events to signal the start and end of the rearrangement process.
 * This component is part of the SDS (System Design Specifications) component library and follows its design guidelines.
 *
 * @tag sds-arrangeable-list
 * @slot - Default slot for list items; typically `sds-tree-node` elements are placed here.
 */
let SdsArrangeableList = (() => {
    var _SdsArrangeableList_isHierarchical_accessor_storage, _SdsArrangeableList__defaultSlot_accessor_storage, _SdsArrangeableList__listItems_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-arrangeable-list')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _isHierarchical_decorators;
    let _isHierarchical_initializers = [];
    let _isHierarchical_extraInitializers = [];
    let __defaultSlot_decorators;
    let __defaultSlot_initializers = [];
    let __defaultSlot_extraInitializers = [];
    let __listItems_decorators;
    let __listItems_initializers = [];
    let __listItems_extraInitializers = [];
    var SdsArrangeableList = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsArrangeableList_isHierarchical_accessor_storage.set(this, __runInitializers(this, _isHierarchical_initializers, false));
            _SdsArrangeableList__defaultSlot_accessor_storage.set(this, (__runInitializers(this, _isHierarchical_extraInitializers), __runInitializers(this, __defaultSlot_initializers, void 0)));
            _SdsArrangeableList__listItems_accessor_storage.set(this, (__runInitializers(this, __defaultSlot_extraInitializers), __runInitializers(this, __listItems_initializers, void 0)));
            this._listManager = __runInitializers(this, __listItems_extraInitializers);
            this.handleSlotChange = throttle(() => {
                var _a;
                (_a = this._listManager) === null || _a === void 0 ? void 0 : _a.refresh();
            }, 100, { leading: true, trailing: true });
            this.mutationObserver = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.type === 'childList') {
                        this.handleSlotChange();
                    }
                });
            });
        }
        /**
         * Determines whether the list supports a hierarchical structure.
         * If set to `true`, the list allows nested items (tree-like structure).
         * If `false`, the list will be flat, with only top-level items.
         *
         * @attribute hierarchical - Corresponding HTML attribute to set this property.
         */
        get isHierarchical() { return __classPrivateFieldGet(this, _SdsArrangeableList_isHierarchical_accessor_storage, "f"); }
        set isHierarchical(value) { __classPrivateFieldSet(this, _SdsArrangeableList_isHierarchical_accessor_storage, value, "f"); }
        get _defaultSlot() { return __classPrivateFieldGet(this, _SdsArrangeableList__defaultSlot_accessor_storage, "f"); }
        set _defaultSlot(value) { __classPrivateFieldSet(this, _SdsArrangeableList__defaultSlot_accessor_storage, value, "f"); }
        get _listItems() { return __classPrivateFieldGet(this, _SdsArrangeableList__listItems_accessor_storage, "f"); }
        set _listItems(value) { __classPrivateFieldSet(this, _SdsArrangeableList__listItems_accessor_storage, value, "f"); }
        async connectedCallback() {
            super.connectedCallback();
            await this.updateComplete;
            appendStylesToTheGlobalStyleRoot('sds-arrangeable-list', stylesGlobal.cssText);
            this.registerListManager();
            if (!isNil(this._defaultSlot)) {
                this.mutationObserver.observe(this._defaultSlot, {
                    childList: true,
                    subtree: true,
                });
            }
            else {
                console.error('defaultSlot is undefined');
            }
        }
        disconnectedCallback() {
            var _a;
            super.disconnectedCallback();
            (_a = this._listManager) === null || _a === void 0 ? void 0 : _a.unregister();
            this.mutationObserver.disconnect();
        }
        firstUpdated() {
            this.handleSlotChange();
        }
        render() {
            return html `<slot></slot>`;
        }
        static collapseClosestNode(element) {
            const node = element.closest('sds-tree-node');
            if (!isNil(node) && !node.isCollapsed) {
                node.toggle().catch(e => console.error(e));
            }
        }
        findTree(items) {
            return items.find(item => item instanceof SdsTree);
        }
        registerListManager() {
            var _a;
            if (isNil(this._listManager)) {
                this._listManager = this.createListManager(this._listItems);
            }
            (_a = this._listManager) === null || _a === void 0 ? void 0 : _a.register();
        }
        createListManager(items = []) {
            const tree = this.findTree(items);
            if (items.length === 0) {
                return undefined;
            }
            else if (!isNil(tree) && this.isHierarchical) {
                return this.prepareSdsTree(tree);
            }
            else if (this.isHierarchical) {
                return this.createHierarchical(items);
            }
            else {
                return this.createFlatList(items);
            }
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        createHierarchical(_items) {
            throw new Error('Not implemented');
        }
        prepareSdsTree(tree) {
            tree.dataset.dragId = uniqueId('arrangeable-list-');
            let timerId;
            let currentOverItem;
            return ArrangeableList.create({
                manipulator: createHierarchicalListManipulator({
                    itemSelector: 'sds-tree-node',
                }),
                inspector: createHierarchicalListInspector({
                    rootContainerSelector: `sds-tree[data-drag-id="${tree.dataset.dragId}"]`,
                    containerSelector: 'sds-tree-node, sds-tree',
                    itemSelector: 'sds-tree-node',
                    handleSelector: ':is(sds-arrangeable-list-handle, sds-tree-node:not(sds-tree-node:has(>sds-arrangeable-list-handle))',
                }),
                onItemOver: item => {
                    if (isNil(currentOverItem) || currentOverItem !== item) {
                        currentOverItem = item;
                        clearTimeout(timerId);
                        timerId = delay((overItem) => {
                            const overNode = overItem.closest('sds-tree-node');
                            if (!isNil(overNode) && overNode.isCollapsed) {
                                overNode.toggle().catch(e => console.error(e));
                            }
                        }, 1500, item);
                    }
                },
                onRearrangementFinished: item => {
                    currentOverItem = undefined;
                    const treeNode = item.closest('sds-tree-node');
                    if (!isNil(treeNode)) {
                        treeNode.classList.add('sds-rearranged-item-focused');
                        delay(treeItem => {
                            treeItem.classList.remove('sds-rearranged-item-focused');
                        }, 3000, treeNode);
                    }
                },
                onStartRearrangement: (activeItem, cloneGhost) => {
                    SdsArrangeableList.collapseClosestNode(cloneGhost);
                    SdsArrangeableList.collapseClosestNode(activeItem);
                },
            });
        }
        createFlatList(items) {
            const list = items.find(item => item instanceof SdsList);
            list.dataset.dragId = uniqueId('arrangeable-list-');
            return ArrangeableList.create({
                manipulator: createFlatListManipulator(),
                inspector: createFlatListInspector({
                    rootContainerSelector: `sds-list[data-drag-id="${list.dataset.dragId}"]`,
                    itemSelector: 'sds-list-item',
                    handleSelector: ':is(sds-arrangeable-list-handle)',
                }),
                onRearrangementFinished: item => {
                    const listItem = item.closest('sds-list-item');
                    if (!isNil(listItem)) {
                        item.classList.add('sds-rearranged-item-focused');
                        delay(item => {
                            item.classList.remove('sds-rearranged-item-focused');
                        }, 3000, listItem);
                    }
                },
                multiLevel: false,
            });
        }
    };
    _SdsArrangeableList_isHierarchical_accessor_storage = new WeakMap();
    _SdsArrangeableList__defaultSlot_accessor_storage = new WeakMap();
    _SdsArrangeableList__listItems_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsArrangeableList");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _isHierarchical_decorators = [property({ attribute: 'hierarchical', type: Boolean })];
        __defaultSlot_decorators = [query('slot')];
        __listItems_decorators = [queryAssignedElements()];
        __esDecorate(_classThis, null, _isHierarchical_decorators, { kind: "accessor", name: "isHierarchical", static: false, private: false, access: { has: obj => "isHierarchical" in obj, get: obj => obj.isHierarchical, set: (obj, value) => { obj.isHierarchical = value; } }, metadata: _metadata }, _isHierarchical_initializers, _isHierarchical_extraInitializers);
        __esDecorate(_classThis, null, __defaultSlot_decorators, { kind: "accessor", name: "_defaultSlot", static: false, private: false, access: { has: obj => "_defaultSlot" in obj, get: obj => obj._defaultSlot, set: (obj, value) => { obj._defaultSlot = value; } }, metadata: _metadata }, __defaultSlot_initializers, __defaultSlot_extraInitializers);
        __esDecorate(_classThis, null, __listItems_decorators, { kind: "accessor", name: "_listItems", static: false, private: false, access: { has: obj => "_listItems" in obj, get: obj => obj._listItems, set: (obj, value) => { obj._listItems = value; } }, metadata: _metadata }, __listItems_initializers, __listItems_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsArrangeableList = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsArrangeableList = _classThis;
})();
export { SdsArrangeableList };
